function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isSeq, isPair, isMap } from '../../nodes/identity.js';
import { Pair, createPair } from '../../nodes/Pair.js';
import { Scalar } from '../../nodes/Scalar.js';
import { YAMLSeq } from '../../nodes/YAMLSeq.js';

function resolvePairs(seq, onError) {
  if (isSeq(seq)) {
    for (var i = 0; i < seq.items.length; ++i) {
      var item = seq.items[i];
      if (isPair(item)) continue;else if (isMap(item)) {
        if (item.items.length > 1) onError('Each pair must have its own sequence indicator');
        var pair = item.items[0] || new Pair(new Scalar(null));
        if (item.commentBefore) pair.key.commentBefore = pair.key.commentBefore ? "".concat(item.commentBefore, "\n").concat(pair.key.commentBefore) : item.commentBefore;

        if (item.comment) {
          var _pair$value;

          var cn = (_pair$value = pair.value) !== null && _pair$value !== void 0 ? _pair$value : pair.key;
          cn.comment = cn.comment ? "".concat(item.comment, "\n").concat(cn.comment) : item.comment;
        }

        item = pair;
      }
      seq.items[i] = isPair(item) ? item : new Pair(item);
    }
  } else onError('Expected a sequence for this tag');

  return seq;
}

function createPairs(schema, iterable, ctx) {
  var replacer = ctx.replacer;
  var pairs = new YAMLSeq(schema);
  pairs.tag = 'tag:yaml.org,2002:pairs';
  var i = 0;

  if (iterable && Symbol.iterator in Object(iterable)) {
    var _iterator = _createForOfIteratorHelper(iterable),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var it = _step.value;
        if (typeof replacer === 'function') it = replacer.call(iterable, String(i++), it);
        var key = void 0,
            value = void 0;

        if (Array.isArray(it)) {
          if (it.length === 2) {
            key = it[0];
            value = it[1];
          } else throw new TypeError("Expected [key, value] tuple: ".concat(it));
        } else if (it && it instanceof Object) {
          var keys = Object.keys(it);

          if (keys.length === 1) {
            key = keys[0];
            value = it[key];
          } else {
            throw new TypeError("Expected tuple with one key, not ".concat(keys.length, " keys"));
          }
        } else {
          key = it;
        }

        pairs.items.push(createPair(key, value, ctx));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return pairs;
}

var pairs = {
  collection: 'seq',
  default: false,
  tag: 'tag:yaml.org,2002:pairs',
  resolve: resolvePairs,
  createNode: createPairs
};
export { createPairs, pairs, resolvePairs };